__turbopack_context__.v({
  "grid": "kWU6RG_grid",
  "infoBox": "kWU6RG_infoBox",
});
